<template>
  <div class="seasidetms_star_rating" :title="$t('ratingTemplate', { rating })">
    <div class="seasidetms_star_trans_wrap">
      <span class="seasidetms_theme_icon_star_empty seasidetms_star"></span>
      <span class="seasidetms_theme_icon_star_empty seasidetms_star"></span>
      <span class="seasidetms_theme_icon_star_empty seasidetms_star"></span>
      <span class="seasidetms_theme_icon_star_empty seasidetms_star"></span>
      <span class="seasidetms_theme_icon_star_empty seasidetms_star"></span>
    </div>
    <div
      class="seasidetms_star_color_wrap"
      data-width="width:0%"
      :style="widthRating"
    >
      <div class="seasidetms_star_color_inner">
        <span class="seasidetms_theme_icon_star_full seasidetms_star"></span>
        <span class="seasidetms_theme_icon_star_full seasidetms_star"></span>
        <span class="seasidetms_theme_icon_star_full seasidetms_star"></span>
        <span class="seasidetms_theme_icon_star_full seasidetms_star"></span>
        <span class="seasidetms_theme_icon_star_full seasidetms_star"></span>
      </div>
    </div>
    <span
      class="rating dn"
      itemprop="reviewRating"
      itemscope
      itemtype="https://schema.org/Rating"
    >
      <strong itemprop="ratingValue" v-if="rating">{{ rating }}</strong>
      <strong itemprop="ratingValue" v-else>5</strong>
      out of 5
    </span>
  </div>
</template>

<script>
export default {
  name: 'Rating',
  props: {
    rating: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  computed: {
    widthRating() {
      return `width:${this.rating * 20}%`
    },
  },
}
</script>

<style>
.seasidetms_star_rating {
  margin-bottom: 0 !important;
}
</style>
